import axios from "./axios";
// import { getToken, setUser } from "../utils/comman/Common";
import moment from "moment";

export async function gettaloadresponse() {
  
    const d =
    sessionStorage.getItem("token") &&
    JSON.parse(sessionStorage.getItem("token")).token
    ? JSON.parse(sessionStorage.getItem("token")).token
    : "";
    const e = JSON.parse(sessionStorage.getItem("token"));
    const year = moment().year();
    const month = moment().month() + 1;
      return false
   
}
